import {
  WbBreadcrumb,
  WbBreadcrumbs,
  WbHeader,
  WbHeaderActions,
} from '@agilelab/plugin-wb-platform';
import {
  TaxonomySelector,
  useTaxonomySelection,
} from '@agilelab/plugin-wb-practice-shaper';
import { Content } from '@backstage/core-components';
import { PrototypeTable } from './components/PrototypeTable';
import { WbPage } from '@agilelab/plugin-wb-platform';

export const PrototypeListPage = () => {
  const { shouldDisable } = useTaxonomySelection();

  return (
    <WbPage themeId="home">
      <WbHeader
        title="Backlog"
        breadcrumbs={
          <WbBreadcrumbs aria-label="breadcrumb">
            <WbBreadcrumb>Builder</WbBreadcrumb>
            <WbBreadcrumb>Backlog</WbBreadcrumb>
          </WbBreadcrumbs>
        }
      >
        <WbHeaderActions containerStyle={{ marginLeft: 'auto' }}>
          {!shouldDisable && <TaxonomySelector />}
        </WbHeaderActions>
      </WbHeader>
      <Content>
        <PrototypeTable />
      </Content>
    </WbPage>
  );
};
